import React, { FC, MouseEvent } from 'react'

import { ComplaintsType } from 'api/complaints/complaintsApi'
import { Colors } from 'common-constants/colors'
import { ComplainList } from 'components/block/Complaints/ComplainList'
import { Wrapper } from 'components/page/PhotoViewer/TooltipMenu/ToolTipMenu.styled'
import { ComplaintSvg } from 'components/presentational/svg/ComplaintSvg'
import { RightTopTooltip } from 'components/presentational/Tooltip'

interface TooltipMenuViewUserProps {
  userId: string | undefined
  photoId: number
  tooltipState: boolean
  onHandleMenuClick: (event: MouseEvent) => void
}

export const TooltipMenuViewUser: FC<TooltipMenuViewUserProps> = ({
  userId,
  photoId,
  tooltipState,
  onHandleMenuClick,
}) => {
  if (userId) {
    return (
      <Wrapper onClick={onHandleMenuClick} data-name="photo-viewer-menu-action">
        <ComplaintSvg color={Colors.white} />
        {tooltipState && (
          <RightTopTooltip>
            <ComplainList
              violatorId={Number(userId)}
              complaintType={ComplaintsType.photo}
              entityId={photoId}
              complaintListType={ComplaintsType.photo}
            />
          </RightTopTooltip>
        )}
      </Wrapper>
    )
  }

  console.error(`${userId} - not found - TooltipMenuViewUser`)
  return null
}
